export default {
  install(Vue, options = {}) {


    Vue.prototype.msgSuccess = function (msg) {
      this.$message({ showClose: true, message: msg, type: "success" });
    }

    Vue.prototype.msgError = function (msg) {
      this.$message({ showClose: true, message: msg, type: "error" });
    }

    Vue.prototype.msgWarning = function (msg) {
      this.$message({ showClose: true, message: msg, type: "warning" });
    }

    Vue.prototype.msgInfo = function (msg) {
      this.$message({ showClose: true, message: msg, type: "info" });
    }

    Vue.prototype.repairRichText = function(html) {
      // 去掉<img>中style /width / height属性
      let newContent = html.replace(/<img[^>]*>/gi, (match) => {
        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '')
        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '')
        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '')
        // 去除 style=""这样的属性(非必须,不需要可自行注释)
        match = match.replace(/style\s*=\s*(["'])(?:(?!\1).)*\1/gi, '')
        return match
      })
      // 修改所有style里的width属性为max-width:100%
      newContent = newContent.replace(/style="[^"]+"/gi, (match) => {
        match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;')
        return match
      })
      // 去掉所有<br/>标签
      newContent = newContent.replace(/<br[^>]*\/>/gi, '')
      // img标签添加style属性：max-width:100%;height:auto
      newContent = newContent.replace(/\<img/gi,
          '<img style="max-width:100%;height:auto;display:block;margin-top:0;margin-bottom:0;"'
      )
      // return
      return newContent;
    }

    Vue.prototype.getUseDate = function () {
      let day = this.getTime().dateStr
      let cur_date =  this.$Cookies.get('cur_date')
      if(cur_date){
        let isInvalid = this.isInvalidDate(cur_date,day)
        if(isInvalid){
          this.$Cookies.set('cur_date',day)
          return day
        }else{
          return cur_date
        }
      }else{
        this.$Cookies.set('cur_date',day)
        return day
      }
    }

    //顶部时间
    Vue.prototype.getTime= function(){
      var myDate = new Date();
      var myYear = myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      var myMonth = myDate.getMonth()+1; //获取当前月份(0-11,0代表1月)
      var myToday = myDate.getDate(); //获取当前日(1-31)
      var myDay = myDate.getDay(); //获取当前星期X(0-6,0代表星期天)
      var myHour = myDate.getHours(); //获取当前小时数(0-23)
      var myMinute = myDate.getMinutes(); //获取当前分钟数(0-59)
      var mySecond = myDate.getSeconds(); //获取当前秒数(0-59)
      var week = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
      var dateStr = myYear+'-'+formatTime(myMonth)+'-'+formatTime(myToday)
      var timeStr = formatTime(myHour)+':'+formatTime(myMinute)+':'+formatTime(mySecond)
      return {dateStr: dateStr, timeStr: timeStr}
    };

    function formatTime(str){
      var realNum;
      if(str<10){
        realNum	= '0'+str;
      }else{
        realNum	= str;
      }
      return realNum;
    }

    // 日期格式化
    Vue.prototype._parseTime = function (time, pattern) {
      if (arguments.length === 0 || !time) {
        return null
      }
      const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
      let date
      if (typeof time === 'object') {
        date = time
      } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
          time = parseInt(time)
        } else if (typeof time === 'string') {
          time = time.replace(new RegExp(/-/gm), '/');
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
          time = time * 1000
        }
        date = new Date(time)
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
      }
      const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
        if (result.length > 0 && value < 10) {
          value = '0' + value
        }
        return value || 0
      })
      return time_str
    }

    /**
     * 对象数组根据某一属性排序
     * @param {string} field
     * @param {boolean} rev true表示升序排列，false降序排序
     * @returns {function}
     */
    Vue.prototype._sortBy = function (field, rev) {
      if (rev === undefined) {
        rev = 1;
      } else {
        rev = (rev) ? 1 : -1;
      }
      return function (a, b) {
        let val1 = a[field] * 1;
        let val2 = b[field] * 1;
        if (val1 < val2) {
          return rev * 1;
        } else if (val1 > val2) {
          return rev * -1;
        }
      }
    }

    /**
     * 数字千分号
     * @returns {string}
     */
   function _formatNumber(num) {
      var decimalPart = '';
      num = num ? num.toString() : '0';
      if (num.indexOf('.') !== -1) {
        decimalPart = '.' + num.split('.')[1];
        num = parseInt(num.split('.')[0]);
      }
      var array = num.toString().split('');
      var index = -3;
      while (array.length + index > 0) {
        // 从单词的最后每隔三个数字添加逗号
        array.splice(index, 0, ',');
        index -= 4;
      }
      return array.join('') + decimalPart;
    }

    Vue.prototype.formatWUnit = function(val){
      let num =  (val * 1 / 10000).toString()
      let unitNum = (num * 1).toFixed(2)
      console.log('unitNum=='+unitNum)
      // console.log('unitNum=='+val)
      return unitNum
    }

    /**
     * 数字单位
     * @returns {string}
     */
    Vue.prototype.formatUnit = function(num){
      return _formatNumber(num)
    }

    /**
     * 数字单位
     * @returns {string}
     */
    Vue.prototype.transformUnit = function(num) {
      if(num){
        // num = 3012384616408.37
        // 首先先声明一个金额单位数组
        let AmountUnitlist = ["元", "万元", "亿元", "万元"]
        // 将数字金额转为字符串
        let strnum = num.toString()
        // 声明一个变量用于接收金额单位
        let AmountUnit = ''
        // 循环遍历单位数组
        AmountUnitlist.find((item, index) => {
          let newNum = ''
          // 判断一下传进来的金额是否包含小数点
          if (strnum.indexOf('.') !== -1) {
            // 若有则将小数点前的字符截取出来
            newNum = strnum.substring(0, strnum.indexOf('.'))
          } else {
            // 没有则直接等于原金额
            newNum = strnum
          }
          // 判断一下经过小数点截取后的金额字符长度是否小于5
          if (index >= 2 || newNum.length < 5) {
            // 若小于5则接收当前单位，并跳出迭代
            AmountUnit = item
            return true
          } else {
            // 若不小于5则将经过小数点截取处理过后的字符除以10000后作为下一轮迭代的初始金额重新判断(每一个单位之间相距4位数，故除以10000)
            strnum = (newNum * 1 / 10000).toString()
          }
        })
        let money = {num: 0, unit: ""}
        // 保留2位小数.toFixed(2)
        money.num = (strnum * 1).toFixed(2)
        money.num = _formatNumber(money.num)
        // 接收单位
        money.unit = AmountUnit
        return money
      }
      return {}

    }




    /**
     * 随机生成三位数
     * @returns {boolean}
     */
    Vue.prototype._mathRandom1000 = function() {
      return (Math.random() * 1000).toFixed(0) * 1
    }

    /**
     * 判断是否是手机端
     * @returns {boolean}
     */
    Vue.prototype._isMobile = function() {
      var flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      if (flag) {
        return true
      }
    }

    /**
     * 数字排序
     * @returns {boolean}
     */
    Vue.prototype.sortFormat = function(arrList,type=1) {
      let arr = JSON.parse(JSON.stringify(arrList))
      let sortArr = []
      if (type == 1){
        //倒序
        sortArr = arr.sort(function (a, b) {
          return b - a//倒序
        })
      }else{
        sortArr = arr.sort(function (a, b) {
          return a - b//正序
        })
      }
      return sortArr
    }

    Vue.prototype.isInvalidDate = function(cur_date,day){
      const date1 = new Date(cur_date);
      const date2 = new Date(day);
      if (date1.getTime() < date2.getTime()) {
        console.log("过期的日期");
        return true
      }
      return false
    }

  }
}
